import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api.js';
import LoadingState from '../components/LoadingState.jsx';
import PremiumCrown from '../components/PremiumCrown.jsx';

export default function Community() {
  const [tab, setTab] = useState('courses');
  const [courses, setCourses] = useState([]);
  const [feed, setFeed] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [loadingFeed, setLoadingFeed] = useState(true);

  useEffect(() => {
    api
      .getCourses()
      .then((r) => setCourses(r?.courses || r || []))
      .catch(() => {})
      .finally(() => setLoadingCourses(false));
    api
      .getStoriesFeed()
      .then((r) => setFeed(r?.stories || r || []))
      .catch(() => {})
      .finally(() => setLoadingFeed(false));
  }, []);

  return (
    <div className="screen">
      <div className="screen-header">
        <h1>Explore</h1>
      </div>

      <div className="tab-switch">
        <button className={tab === 'courses' ? 'active' : ''} onClick={() => setTab('courses')}>
          Courses
        </button>
        <button className={tab === 'feed' ? 'active' : ''} onClick={() => setTab('feed')}>
          Feed
        </button>
        <button
          className={tab === 'leaderboard' ? 'active' : ''}
          onClick={() => setTab('leaderboard')}
        >
          Leaders
        </button>
      </div>

      {tab === 'courses' && (
        <LoadingState
          loading={loadingCourses}
          empty={courses.length === 0}
          emptyIcon="🗺️"
          emptyTitle="No shared courses yet"
          emptyHint="Be the first to share one"
        >
          <div className="community-grid">
            {courses.map((c, i) => (
              <div className="course-card" key={c.id || i}>
                <div className="thumb">{c.emoji || '🗺️'}</div>
                <div className="grow">
                  <h4>{c.name || 'Untitled'}</h4>
                  <div className="meta">
                    {c.city || '—'} · {c.holes || 9} holes
                    {c.creatorName && (
                      <>
                        {' · by '}
                        {c.creatorName}
                        <PremiumCrown tier={c.creatorTier} />
                      </>
                    )}
                  </div>
                  <div className="rating">
                    <span>★</span>
                    <span>{c.rating || '4.5'}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </LoadingState>
      )}

      {tab === 'feed' && (
        <div className="stack-sm">
          <Link to="/stories/new" className="feed-card feed-card-hero">
            <div className="grow">
              <h3>Post a story</h3>
              <div className="sub">Share a hole highlight</div>
            </div>
            <div className="round-arrow">＋</div>
          </Link>
          {loadingFeed ? (
            <div className="loading-state">
              <div className="spinner" />
              <span className="loading-state-label">Loading…</span>
            </div>
          ) : feed.length === 0 ? (
            <div className="empty-state">
              <div className="icon">📷</div>
              <h3>No stories yet</h3>
              <p>Post the first one above</p>
            </div>
          ) : (
            feed.map((s, i) => (
              <div className="feed-card" key={s.id || i}>
                <div className="feed-card-icon">📷</div>
                <div className="grow">
                  <h4>{s.displayName || 'Player'}</h4>
                  <div className="sub">{s.caption || '—'}</div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {tab === 'leaderboard' && (
        <div className="empty-state">
          <div className="icon">🏅</div>
          <h3>Leaderboard coming soon</h3>
        </div>
      )}
    </div>
  );
}
